export default {
  en: {
    more: 'Read more',
    less: 'Show less',
  },
};
